import { CircularProgress, Typography } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"
import CriteriaWiseScore from "features/Assignments/CriteriaWiseScore"

type Props = {
  assignmentId: string
  enabled: boolean
}

const MarkingCriteriaContent = ({ assignmentId, enabled }: Props) => {
  const { data, isSuccess, isError, isLoading } = useQuery({
    enabled,
    queryFn: () =>
      api.assignments.getRubrics({ urlParams: { assignmentId: assignmentId } }),
    queryKey: queries.assignments.rubrics(assignmentId).queryKey,
  })

  return (
    <>
      {isSuccess && (
        <div className="flex flex-col gap-3">
          {data.map((criteria, index) => (
            <CriteriaWiseScore {...criteria} key={index} />
          ))}
        </div>
      )}
      {isLoading && (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      )}
      {isError && (
        <Typography>Error loading rubrics. Please try again later</Typography>
      )}
    </>
  )
}

export default MarkingCriteriaContent
